var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { IGetPushNotificationUseCaseType } from '../../../Domain/UseCases/PushNotifications/GetPushNotificationUseCase/IGetPushNotificationUseCase';
import { ICoordinatorServiceType } from '../../../Domain/Services/CoordinatorService/ICoordinatorService';
import { reactive } from '../../Decorators/Reactive';
import { injectable } from './../../../Data/Decorators/Injectable';
import { inject } from './../../../Data/Decorators/Inject';
let PushNotificationScreenViewModel = class PushNotificationScreenViewModel {
    constructor(getPushNotification, coordinatorService) {
        this.getPushNotification = getPushNotification;
        this.coordinatorService = coordinatorService;
        this.viewData = {
            error: '',
            loading: true,
            pushNotification: null
        };
        this.dismiss = this.dismiss.bind(this);
        this.init = this.init.bind(this);
        this.dismissError = this.dismissError.bind(this);
    }
    dismissError() {
        this.updateViewData({ error: '' });
    }
    init(id) {
        this.updateViewData({ loading: true });
        this.getPushNotification.execute(id)
            .then(obs => {
            obs.observe(this, pushNotification => {
                var _a;
                this.updateViewData({
                    pushNotification: pushNotification
                        ? Object.assign(Object.assign({}, pushNotification), { interactions: (_a = pushNotification === null || pushNotification === void 0 ? void 0 : pushNotification.interactions) === null || _a === void 0 ? void 0 : _a.map(interaction => {
                                const onPress = interaction.onPress;
                                interaction.onPress = () => {
                                    this.updateViewData({ loading: true });
                                    return Promise.resolve(onPress === null || onPress === void 0 ? void 0 : onPress())
                                        .then(() => this.updateViewData({ loading: false }))
                                        .catch((error) => this.updateViewData({ loading: false, error: error.message }));
                                };
                                return interaction;
                            }) }) : null,
                    loading: false
                });
            });
        })
            .catch(error => {
            this.updateViewData({
                error: error.message,
                loading: false
            });
        });
    }
    dismiss(id) {
        this.updateViewData({ loading: true });
        this.coordinatorService.dismissPushNotifications(id)
            .then(() => {
            this.updateViewData({ loading: false });
        })
            .catch(error => {
            this.updateViewData({
                error: error.message,
                loading: false
            });
        });
    }
    updateViewData(update) {
        this.viewData = Object.assign(Object.assign({}, this.viewData), update);
    }
};
__decorate([
    reactive(),
    __metadata("design:type", Object)
], PushNotificationScreenViewModel.prototype, "viewData", void 0);
PushNotificationScreenViewModel = __decorate([
    injectable(),
    __param(0, inject(IGetPushNotificationUseCaseType)),
    __param(1, inject(ICoordinatorServiceType)),
    __metadata("design:paramtypes", [Object, Object])
], PushNotificationScreenViewModel);
export { PushNotificationScreenViewModel };
